export const heroText = {
  en: {
    title: "41st",
    chaturmasya: "Chaturmasya",
    vratotsava: "Vratothsava",
    year: "2026",

    countdownTitle: "Sacred Beginning In",
    countdownSub: "Chaturmasya Vratothsava",
    waiting: "Awaiting the sacred vow",

    duration: "Duration",
    venue: "Venue",
    yearLabel: "Year",

    durationValue: "60 Days",
    venueValue: "Sagara",
    yearValue: "2026",

    days: "Days",
    hours: "Hours",
    minutes: "Minutes",
    seconds: "Seconds",
  },

  kn: {
    title: "೪೧ನೇ",
    chaturmasya: "ಚಾತುರ್ಮಾಸ್ಯ",
    vratotsava: "ವ್ರತೋತ್ಸವ",
    year: "೨೦೨೬",

    countdownTitle: "ಪವಿತ್ರ ಆರಂಭಕ್ಕೆ",
    countdownSub: "ಚಾತುರ್ಮಾಸ್ಯ ವ್ರತೋತ್ಸವ",
    waiting: "ಪವಿತ್ರ ವ್ರತದ ನಿರೀಕ್ಷೆಯಲ್ಲಿ",

    duration: "ಅವಧಿ",
    venue: "ಸ್ಥಳ",
    yearLabel: "ವರ್ಷ",

    durationValue: "೬೦ ದಿನಗಳು",
    venueValue: "ಸಾಗರ",
    yearValue: "೨೦೨೬",
    days: "ದಿನಗಳು",
    hours: "ಗಂಟೆಗಳು",
    minutes: "ನಿಮಿಷಗಳು",
    seconds: "ಸೆಕೆಂಡುಗಳು",
  },
};